import { Icon } from "../icon";

export const RequiredAsterisk = () => (
  <Icon className="w-4 h-4 mx-2 text-red-550" name="regularAsterisk" />
);
